import withLoadable from 'hoc/withLoadable';

const MultiCarousel = /* #__LOADABLE__ */ () =>
    import(
        /* webpackChunkName: "components-MultiCarousel" */ './MultiCarousel'
    );

export default withLoadable(MultiCarousel);
